import { createApp } from 'vue'
import App from './App.vue'
import router from "./router" //路由配置
import store from './store'  //vuex
import ElementPlus from 'element-plus' //全局引进elementui
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { ElDrawer } from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/index.css'
import '@/assets/global-table.css' // 全局表格样式
import '@/assets/global-search.css' // 全局搜索栏样式（多行对齐+控件统一尺寸）
import "@/config/bus" //全局总线
import axios from '@/config/axios'; // 引入封装的axios实例
import Echarts from 'vue-echarts'
import * as echarts from 'echarts'
import Pagination from '@/components/Pagination.vue'


const app = createApp(App);

// 根据开发环境更新全局配置axios
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '/api';
}

// 修改分页器默认文字
const customLocale = {
  ...zhCn,
  pagination: {
    goto: '前往',
    pagesize: '条/页',
    total: `共 {total} 条`,
    pageClassifier: '页',
    deprecationWarning: '',
  }
}

// 使用路由
app.use(router);
app.use(store);
// app.use(ElementPlus);
app.use(ElementPlus, { locale: customLocale });
app.use(ElDrawer);

app.config.globalProperties.$axios = axios; // 将axios挂载到全局
app.config.globalProperties.$echarts = echarts; // 将echarts挂载到全局

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

// 注册全局分页器组件
app.component('Pagination', Pagination);
 
app.mount('#app');